"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextPowerOfTwo = exports.isPowerOfTwo = exports.resizeTexture = void 0;
const resizeTexture = (pixels, width, height, newWidth, newHeight) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Runtime error.');
    }
    canvas.width = width;
    canvas.height = height;
    const nc = document.createElement('canvas');
    const nctx = nc.getContext('2d');
    if (!nctx) {
        throw new Error('Runtime error.');
    }
    nc.width = newWidth;
    nc.height = newHeight;
    const cid = ctx.createImageData(width, height);
    for (let i = 0, size = width * height * 4; i < size; i += 4) {
        cid.data[i] = pixels[i];
        cid.data[i + 1] = pixels[i + 1];
        cid.data[i + 2] = pixels[i + 2];
        cid.data[i + 3] = pixels[i + 3];
    }
    ctx.putImageData(cid, 0, 0);
    nctx.drawImage(canvas, 0, 0, newWidth, newHeight);
    return new Uint8Array(nctx.getImageData(0, 0, newWidth, newHeight).data);
};
exports.resizeTexture = resizeTexture;
const isPowerOfTwo = (n) => (n & (n - 1)) === 0;
exports.isPowerOfTwo = isPowerOfTwo;
const nextPowerOfTwo = (n) => {
    --n;
    for (let i = 1; i < 32; i <<= 1) {
        n = n | (n >> i);
    }
    return n + 1;
};
exports.nextPowerOfTwo = nextPowerOfTwo;
